import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";

const assertingPartyDetails = new SchemaValidator(
	Type.Object({
		entityId: Type.Union([Type.String(), Type.Null()]),
		wantAuthnRequestsSigned: Type.Union([Type.Boolean(), Type.Null()]),
		singleSignOnServiceLocation: Type.Union([Type.String(), Type.Null()]),
		singleSignOnServiceBindingUrn: Type.Union([Type.String(), Type.Null()]),
		singleLogoutServiceLocation: Type.Union([Type.String(), Type.Null()]),
		singleLogoutServiceResponseLocation: Type.Union([Type.String(), Type.Null()]),
		singleLogoutServiceBindingUrn: Type.Union([Type.String(), Type.Null()]),
		signingAlgorithms: Type.Array(Type.String()),
		verificationX509Credentials: Type.Array(
			Type.Object({
				certificate: Type.String(),
				type: Type.String(),
			}),
		),
		encryptionX509Credentials: Type.Array(
			Type.Object({
				certificate: Type.String(),
				type: Type.String(),
			}),
		),
	}),
);

const attributeMapping = new SchemaValidator(
	Type.Object({
		email: Type.Union([Type.String(), Type.Null()]),
		name: Type.Union([Type.String(), Type.Null()]),
		role: Type.Union([Type.String(), Type.Null()]),
		linkage: Type.Union([Type.String(), Type.Null()]),
	}),
);

const roleMapping = new SchemaValidator(
	Type.Object({
		id: Type.Number(),
		attribute: Type.String(),
		privilegeGroupId: Type.Number(),
	}),
);

const relyingPartyRegistration = new SchemaValidator(
	Type.Object({
		instituteId: Type.String(),
		registrationId: Type.String(),
		metadataLocation: Type.Union([Type.String(), Type.Null()]),
		nameIdFormat: Type.Union([Type.String(), Type.Null()]),
		assertingPartyDetails: Type.Union([assertingPartyDetails.schema, Type.Null()]),
		attributeMapping: Type.Union([attributeMapping.schema, Type.Null()]),
		roleMappings: Type.Union([Type.Array(roleMapping.schema), Type.Null()]),
		enabled: Type.Boolean(),
	}),
);

const getRelyingPartyRegistrations = new SchemaValidator(
	Type.Object({
		content: Type.Array(relyingPartyRegistration.schema),
	}),
);

const addRoleMapping = new SchemaValidator(
	Type.Object({
		attribute: Type.String(),
		privilegeGroupId: Type.Number(),
	}),
);

const updateRelyingPartyRegistration = new SchemaValidator(
	Type.Object({
		metadataLocation: Type.Union([Type.String(), Type.Null()]),
		nameIdFormat: Type.Union([Type.String(), Type.Null()]),
		assertingPartyDetails: Type.Union([assertingPartyDetails.schema, Type.Null()]),
		attributeMapping: Type.Union([attributeMapping.schema, Type.Null()]),
		enabled: Type.Union([Type.Boolean(), Type.Null()]),
	}),
);

const createRelyingPartyRegistration = new SchemaValidator(
	Type.Object({
		instituteId: Type.String(),
		registrationId: Type.Union([Type.String(), Type.Null()]),
		metadataLocation: Type.Union([Type.String(), Type.Null()]),
		nameIdFormat: Type.Union([Type.String(), Type.Null()]),
		assertingPartyDetails: Type.Union([assertingPartyDetails.schema, Type.Null()]),
		attributeMapping: Type.Union([attributeMapping.schema, Type.Null()]),
		roleMappings: Type.Union([Type.Array(addRoleMapping.schema), Type.Null()]),
		enabled: Type.Union([Type.Boolean(), Type.Null()]),
	}),
);

const getRoleMappingPresets = new SchemaValidator(
	Type.Array(
		Type.Object({
			preset: Type.Union([Type.Literal("STUDENT"), Type.Literal("INSTRUCTOR"), Type.Literal("ADMIN")]),
			privilegeGroupId: Type.Number(),
		}),
	),
);

export default {
	relyingPartyRegistration,
	getRelyingPartyRegistrations,
	addRoleMapping,
	updateRelyingPartyRegistration,
	createRelyingPartyRegistration,
	getRoleMappingPresets,
};
